import deleteFolderRequest from 'owa-service/lib/factory/deleteFolderRequest';
import folderId from 'owa-service/lib/factory/folderId';
import deleteFolderOperation from 'owa-service/lib/operation/deleteFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function deleteFolders(folderIdsToDelete, permanentlyDelete) {
    if (folderIdsToDelete.length === 0 ||
        folderIdsToDelete.filter(function (id) { return id !== undefined; }).length === 0) {
        return Promise.resolve();
    }
    return deleteFolderOperation({
        Header: getJsonRequestHeader(),
        Body: deleteFolderRequest({
            DeleteType: permanentlyDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            FolderIds: folderIdsToDelete
                .filter(function (id) { return id !== undefined; })
                .map(function (folderIdToDelete) { return folderId({ Id: folderIdToDelete }); }),
        }),
    }).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('Delete folder failed: ' + responseItem.ResponseClass);
        }
    });
}
//# sourceMappingURL=deleteFolders.js.map